<template>
  <div style="padding: 5px;">
    <a-card>
      <div style="text-align: right;">
        <span
          class="ant-descriptions-title"
          style="float: left; margin-top: 5px;"
        >
          <a-icon type="tags" /> List Parcel type
        </span>
        <a-input
          placeholder="Search..."
          style="width: 100%; max-width: 350px; margin-right: 5px;"
          v-model="filter.query"
          @change="onFilter"
        />
        <a-button slot="extra" type="primary" @click="showDrawerAdd">
          <a-icon type="plus" /> Add New
        </a-button>
      </div>

      <a-drawer
        v-if="visibleAdd"
        title="Add New"
        placement="right"
        :visible="visibleAdd"
        @close="closeDrawerAdd"
        :width="450"
      >
        <AddParcelType
          :createdOnView="createdOnView"
          :closeDrawerAdd="closeDrawerAdd"
        />
      </a-drawer>

      <a-drawer
        v-if="visibleUpdate"
        title="Edit"
        placement="right"
        :visible="visibleUpdate"
        @close="closeDrawerUpdate"
        :width="450"
      >
        <UpdateParcelType
          :closeDrawerUpdate="closeDrawerUpdate"
          :itemId="itemId"
          :updateOnView="updateOnView"
          :deleteOnView="deleteOnView"
        />
      </a-drawer>

      <a-table
        :loading="loading"
        size="small"
        :columns="column"
        :data-source="list"
        rowKey="id"
        style="margin-top: 5px;"
        :pagination="{
          current: currentPage,
          onChange: (page) => {
            this.currentPage = page;
          },
          pageSize: limit,
        }"
      >
        <div slot="footer">
          <a-button
            :loading="loading"
            type="link"
            @click="onPagination"
            :disabled="!isPagination"
          >
            <a-icon type="reload" /> Load more
          </a-button>
        </div>
        <div slot="stt" slot-scope="text, record, index">
          {{ index + 1 }}
        </div>

        <div slot="createdAt" slot-scope="text, record">
          <p>
            {{ record.createdAt | formatDateHour }}
          </p>
        </div>

        <div slot="updatedAt" slot-scope="text, record">
          <p>
            {{ record.updatedAt | formatDateHour }}
          </p>
        </div>

        <div slot="action" slot-scope="text, record">
          <a-button
            icon="edit"
            @click="showDrawerUpdate(record)"
            class="icon-update"
          >
            Edit
          </a-button>
        </div>
      </a-table>
    </a-card>
  </div>
</template>
<script>
import AddParcelType from "./addParcelType";
import UpdateParcelType from "./updateParcelType";
import queryItem from "../data/queryItem";
import { column } from "../constants/dataColumn";
import {
  updateForCreated,
  updateForUpdated,
  updateForDeleted,
} from "@/services/updateOnViewConfig";
import debounce from "lodash/debounce";
const limit = 10;
const startPage = 1;
const defaultFilter = { query: "" };
export default {
  components: {
    AddParcelType,
    UpdateParcelType,
  },
  data() {
    this.onFilter = debounce(this.onFilter, 500);
    return {
      itemId: null,
      visibleAdd: false,
      visibleUpdate: false,
      loading: true,
      column,
      list: [],
      limit,
      filter: defaultFilter,
      currentPage: startPage,
      totalPage: startPage,
      isPagination: true,
    };
  },
  methods: {
    showDrawerAdd() {
      this.visibleAdd = true;
    },
    closeDrawerAdd() {
      this.visibleAdd = false;
    },
    showDrawerUpdate(record) {
      this.itemId = record.id;
      this.visibleUpdate = true;
    },
    closeDrawerUpdate() {
      this.visibleUpdate = false;
    },
    updateOnView(item) {
      this.list = updateForUpdated(this.list, item);
    },
    createdOnView(item) {
      this.list = updateForCreated({
        list: this.list,
        item,
        limit,
        currentPage: this.currentPage,
      });
    },
    deleteOnView(item) {
      this.list = updateForDeleted(this.list, item);
    },

    getParcelTypes(flag) {
      this.loading = true;
      this.$apollo
        .query({
          fetchPolicy: "no-cache",
          query: queryItem.queryGetAll,
          variables: {
            query: this.filter.query,
            limit,
            page: this.totalPage,
          },
        })
        .then(({ data }) => {
          if (data.getAllParcelType) {
            if (flag === "FILTER") {
              this.list = [...data.getAllParcelType];
            } else if (flag === "PAGINATION") {
              this.list = this.list.concat([...data.getAllParcelType]);
            } else {
              this.list = [...data.getAllParcelType];
            }

            // check is pagniation
            if (data.getAllParcelType.length < limit) {
              this.isPagination = false;
            } else {
              this.isPagination = true;
            }
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log("Không lấy được danh sách vai", error);
        });
    },

    onFilter() {
      this.currentPage = startPage;
      this.totalPage = startPage;
      this.getParcelTypes("FILTER");
    },
    onPagination() {
      if (this.isPagination) {
        this.totalPage += 1;
        this.currentPage = this.totalPage;
        this.getParcelTypes("PAGINATION");
      }
    },
  },
  created() {
    this.getParcelTypes();
  },
};
</script>
